import React from 'react';
import classnames from 'classnames';

export const SearchLocationIcon = () => (
    <i className="fas fa-search-location"></i>
);

export const LoadingIcon = () => (
    <i className="fas fa-spinner fa-2x fa-flip-horizontal fa-spin" style={{ "color": '#0074d9' }}></i>
);

export const LoadingIconChange = ({ tamanio, color }) => (
    <i className={classnames("fas fa-spinner fa-spin", { tamanio }, { color })}></i>
);

export const SearchIcon = () => (
    <i className="fas fa-search"></i>
);

export const FilterIcon = () => (
    <i className="fas fa-filter"></i>
);

export const RefreshIcon = () => (
    <i className="fa fa-retweet"></i>
);

export const WarningIcon = () => (
    <i className="fas fa-exclamation-triangle"></i>
);

export const EyerIcon = () => (
    <i className="fas fa-eye"></i>
);

export const CaretDownIcon = () => (
    <i className="fas fa-caret-down"></i>
);

export const CaretRightIcon = () => (
    <i className="fas fa-caret-right"></i>
);

export const CaretLetIcon = () => (
    <i className="fa fa-caret-left"></i>
);

export const ListAltIcon = () => (
    <i className="far fa-list-alt"></i>
);

export const CheckIcon = ({ titulo }) => (
    <i className="fas fa-check">{titulo}</i>
);

export const CheckDouble = () => (
    <i className="fas fa-check-double"></i>
);

export const ThumbsDown = () => (
    <i className="far fa-thumbs-down"></i>
);
export const EraserIcon = () => (
    <i className="fas fa-eraser"></i>
);

export const IdCardIcon = () => (
    <i className="far fa-id-card"></i>
);

export const LockOpenIcon = () => (
    <i className="fas fa-lock-open"></i>
);

export const EditIcon = () => (
    <i className="fas fa-edit"></i>
);

export const CloseIcon = () => (
    <i className="fas fa-times"></i>
);

export const InfoIcon = () => (
    <i className="fas fa-info-circle"></i>
);

export const PaintBrushIcon = ({ titulo }) => (
    <i className="fas fa-paint-brush">{titulo}</i>
);

export const HanPointerIcon = () => (
    <i className="far fa-hand-pointer"></i>
);

export const PencilAltIcon = () => (
    <i className="fas fa-pencil-alt"></i>
);

export const ErrorIcon = () => (
    <i className="fas fa-times-circle"></i>
);

export const UserIcon = () => (
    <i className="far fa-user"></i>
);

export const UnlockAltIcon = () => (
    <i className="fas fa-unlock-alt"></i>
);

export const UndoIcon = () => (
    <i className="fas fa-undo"></i>
);

export const EnvelopeIcon = () => (
    <i className="far fa-envelope"></i>
);

export const AddressIcon = () => (
    <i className="fas fa-address-card"></i>
);

export const MailIcon = () => (
    <i className="fas fa-at"></i>
);

export const Briefcase = () => (
    <i className="fas fa-briefcase"></i>
);

export const LaptopIcon = () => (
    <i className="fas fa-laptop"></i>
);

export const MarkerAltIcon = () => (
    <i className="fas fa-map-marker-alt"></i>
);

export const ArrowLeftIcon = () => (
    <i className="fas fa-arrow-left"></i>
);

export const CalculatorIcon = () => (
    <i className="fas fa-calculator"></i>
);

export const SaveIcon = () => (
    <i className="fas fa-save"></i>
);

export const DeleteIcon = () => (
    <i className="fas fa-trash"></i>
);

export const PolygonIcon = () => (
    <i className="fas fa-draw-polygon mr-2"></i>
);

export const TrashIcon = () => (
    <i className="fas fa-trash"></i>
);

export const HighlighterIcon = () => (
    <i className="fas fa-highlighter"></i>
);

export const ExpandIcon = () => (
    <i className="fas fa-expand"></i>
);

export const CheckCircleIcon = () => (
    <i className="far fa-check-circle"></i>
);

export const BanIcon = () => (
    <i className="fas fa-ban"></i>
);

export const PlaneIcon = () => (
    <i className="far fa-paper-plane"></i>
);

export const EyeIcon = () => (
    <i className="fas fa-eye"></i>
);

export const EyeSlash = () => (
    <i className="fas fa-eye-slash"></i>
);

export const PaperclipIcon = () => (
    <i className="fas fa-paperclip"></i>
);

export const ExChangeAltIcon = () => (
    <i className="fas fa-exchange-alt"></i>
);

export const HotelIcon = () => (
    <i className="fas fa-hotel"></i>
);

export const ListOlIcon = () => (
    <i className="fas fa-list-ol"></i>
);

export const FileAlt = () => (
    <i className="fas fa-file-alt"></i>
);

export const TintIcon = () => (
    <i className="fas fa-tint"></i>
);

export const DollarSignIcon = () => (
    <i className="fas fa-dollar-sign"></i>
);

export const SignalIcon = () => (
    <i className="fas fa-signal"></i>
);

export const WrenchIcon = () => (
    <i className="fas fa-wrench"></i>
);

export const PlayIcon = () => (
    <i className="fas fa-play"></i>
);

export const StopIcon = () => (
    <i className="fas fa-stop"></i>
);

export const BullhornIcon = () => (
    <i className="fas fa-bullhorn"></i>
);

export const BookIcon = () => (
    <i className="fas fa-book"></i>
);

export const MinusIcon = () => (
    <i className="fas fa-angle-down"></i>
);

export const FileUpload = () => (
    <i className="fas fa-file-upload"></i>
);

export const ImagesIcon = () => (
    <i className="fas fa-images"></i>
);

export const ImageIcon = () => (
    <i className="far fa-image"></i>
);

export const UploadIcon = () => (
    <i className="fas fa-upload"></i>
);

export const CloudIcon = () => (
    <i className="fas fa-cloud"></i>
);

export const PlusIcon = () => (
    <i className="fas fa-plus"></i>
);

export const CloudUploadAlt = () => (
    <i className="fas fa-cloud-upload-alt"></i>
);

export const LockIcon = () => (
    <i className="fas fa-lock"></i>
);

export const UnlockIcon = () => (
    <i className="fas fa-unlock"></i>
);

export const FileExport = () => (
    <i className="fas fa-file-export"></i>
);

export const ClipboardList = () => (
    <i className="fas fa-clipboard-list"></i>
);

export const Clipboard = () => (
    <i className="far fa-clipboard"></i>
);

export const SyncAltIcon = () => (
    <i className="fas fa-sync-alt"></i>
);

export const MapaIcon = () => (
    <i className="fas fa-map"></i>
);

export const PowerIcon = () => (
    <i className="fas fa-power-off"></i>
);

export const LikeIcon = () => (
    <i className="far fa-thumbs-up"></i>
);

export const DisLikeIcon = () => (
    <i className="far fa-thumbs-down"></i>
);

export const SignOutIcon = () => (
    <i className="fas fa-sign-out-alt"></i>
);

export const FolderOpenIcon = () => (
    <i className="fas fa-folder-open"></i>
);

export const BarrasIcon = () => (
    <i className="fas fa-bars"></i>
);

export const CapasIcon = () => (
    <i className="fas fa-layer-group"></i>
);

export const UserOperation = () => (
    <i className="fas fa-user-cog"></i>
);